import { render } from "./Fase4Page.vue?vue&type=template&id=e29fbcda&scoped=true"
const script = {}

import "./Fase4Page.vue?vue&type=style&index=0&id=e29fbcda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e29fbcda"]])

export default __exports__